import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/lib/data";

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="section bg-secondary/40">
      <div className="container-page grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <p className="label-eyebrow">Frequently Asked</p>
          <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-forest mt-5 leading-[1.05]">
            Small questions, <span className="italic text-terracotta">real answers.</span>
          </h2>
          <p className="mt-6 text-forest/70 leading-relaxed">
            Couldn't find what you're looking for? Call the clinic — we'll happily walk you through it.
          </p>
        </div>

        <div className="lg:col-span-7">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-${i}`} className="border-sand">
                <AccordionTrigger className="text-left font-serif text-xl md:text-2xl text-forest hover:text-terracotta hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-forest/75 text-base leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
